import React, {Fragment} from "react";

export default class OrderCancelProvider extends React.Component {
    render() {
        return <Fragment/>
    }
}